import { FunctionComponent } from "react"
import { Button, Form, InputGroup } from "react-bootstrap"

interface IFilterDateTimeField {
	filter: string // yyyy-mm-ddThh:mm:ss
	setFilter: (v: string) => void
	label: string
	defaultTime?: string // 00:00
}
const FilterDateTimeField: FunctionComponent<IFilterDateTimeField> = ({
	filter,
	setFilter,
	label,
	defaultTime = "00:00",
}) => {
	const date = filter?.split("T")?.[0] || ""
	const time = filter?.split("T")?.[1] || ""
	const timeWithDefault = time || defaultTime
	const minWidth = label.length + 17 + "em"
	return (
		<InputGroup size="sm" style={{ minWidth: minWidth }}>
			<InputGroup.Text>{label}</InputGroup.Text>
			<Form.Control
				type="date"
				value={date}
				onChange={(e) => {
					setFilter(e.target.value + "T" + timeWithDefault)
				}}
				style={{ flexBasis: "9em" }}
			/>
			<Form.Control
				type="time"
				value={time}
				onChange={(e) => {
					setFilter(date + "T" + e.target.value)
				}}
				style={{ flexBasis: "7em" }}
				disabled={!date}
			/>
			{filter && (
				<Button variant="outline-secondary" size="sm" onClick={() => setFilter("")}>
					Clear
				</Button>
			)}
		</InputGroup>
	)
}
export default FilterDateTimeField
